export default __webpack_public_path__ + "static/media/ekedc.2e0f582e.jpg";